
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M21 8.00001V17.88L22.85 19.73C22.95 19.51 23 19.26 23 19V7.00001C23 5.89001 22.1 5.00001 21 5.00001H13.41L16.35 2.06001C16.55 1.86001 16.55 1.55001 16.35 1.35001C16.15 1.15001 15.84 1.15001 15.64 1.35001L12 4.99001L8.36 1.35001C8.16 1.15001 7.85 1.15001 7.65 1.35001C7.45 1.55001 7.45 1.86001 7.65 2.06001L10.59 5.00001H8.12L10.12 7.00001H20C20.55 7.00001 21 7.45001 21 8.00001ZM3.12 2.83001C2.73 2.44001 2.1 2.44001 1.71 2.83001C1.32 3.22001 1.32 3.85001 1.71 4.24001L2.53 5.06001C1.65 5.28001 1 6.06001 1 7.00001V19C1 20.1 1.9 21 3 21H18.46L19.75 22.29C20.14 22.68 20.77 22.68 21.16 22.29C21.52 21.93 21.53 21.37 21.23 20.98H21.26L3.12 2.83001ZM3 18V8.00001C3 7.45001 3.45 7.00001 4 7.00001H4.46L16.46 19H4C3.45 19 3 18.55 3 18Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-tv-off`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconTvOff

    ```js
    <b-new-b-icon-tv-off />
    ```
</docs>


